/*!
 * mbg-external-links.js
 * Force every link that points OFF the Shopify store to open in a new tab.
 * Adds target="_blank" rel="noopener noreferrer" to any <a href> whose host
 * is not the storefront, myshopify domain, *.shopify.com, *.myshopify.com,
 * or shop.app. Internal links, anchors, mailto:, tel:, and JS URLs are
 * left alone. Also handles dynamically injected links (cart drawer, quick
 * view, ajax) via MutationObserver.
 */
(function () {
  var INTERNAL_HOSTS = [
    'flipsalonandextensions.com',
    'www.flipsalonandextensions.com',
    'ii0uft-qh.myshopify.com'
  ];

  function isInternal(host) {
    if (!host) return true;
    host = host.toLowerCase();
    if (INTERNAL_HOSTS.indexOf(host) !== -1) return true;
    if (host === location.hostname.toLowerCase()) return true;
    if (host.slice(-13) === '.shopify.com') return true;
    if (host.slice(-15) === '.myshopify.com') return true;
    if (host === 'shop.app' || host.slice(-9) === '.shop.app') return true;
    return false;
  }

  function mark(a) {
    if (!a || a.dataset.mbgExtScanned === '1') return;
    a.dataset.mbgExtScanned = '1';
    var href = a.getAttribute('href');
    if (!href) return;
    if (/^(#|mailto:|tel:|sms:|javascript:|blob:|data:)/i.test(href)) return;
    var url;
    try { url = new URL(href, location.href); } catch (e) { return; }
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return;
    if (isInternal(url.hostname)) return;
    a.setAttribute('target', '_blank');
    var rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
    if (rel.indexOf('noopener') === -1) rel.push('noopener');
    if (rel.indexOf('noreferrer') === -1) rel.push('noreferrer');
    a.setAttribute('rel', rel.join(' '));
  }

  function scan(root) {
    (root || document).querySelectorAll('a[href]').forEach(mark);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  if (window.MutationObserver) {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type === 'childList') {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.tagName === 'A') { mark(node); }
            else if (node.querySelectorAll) { scan(node); }
          });
        } else if (m.type === 'attributes' && m.target && m.target.tagName === 'A') {
          m.target.dataset.mbgExtScanned = '';
          mark(m.target);
        }
      }
    });
    mo.observe(document.documentElement, {
      childList: true, subtree: true,
      attributes: true, attributeFilter: ['href']
    });
  }
})();
